import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { getImgixUrl } from 'ck-utils';
import { DividerWithLogo, Icon, Typography } from 'ck-ui';
import { SignUpForm } from './SignUpForm';
import { TermsAndPrivacyLinks } from '../TermsAndPrivacyLinks';
import styles from './PopupSignup.module.scss';

const PopupModalContent = ({
  heroImage,
  hasSignedUp,
  heading,
  desc,
  giftImage,
  source,
  onSubmitSuccess,
  successHeading,
  successDesc,
  trackEvent,
}) => {
  const isMobile = useMedia('(max-width: 767px)');

  return (
    <div className="is-flex is-full-width is-full-height">
      {!isMobile && (
        <div
          className={classnames('is-half-width', styles.image)}
          style={{ backgroundImage: source === 'signup_popup' ? `url('${getImgixUrl(heroImage, ['w=800'])}')` : heroImage }}
        />
      )}
      <div className={classnames(styles.textWrapper, 'is-half-width is-flex is-flex-column')}>
        <DividerWithLogo />
        <Typography
          variant="heading5"
          align="centered"
          uppercase
        >{hasSignedUp ? successHeading || 'CONGRATULATIONS, YOU HAVE SUCCESSFULLY ENTERED THE DRAW!' : heading}
        </Typography>
        {hasSignedUp ? (
          <>
            <Typography
              color="black-bis"
              display="block"
              align="centered"
              className={styles.largeMarginTop}
            >
              {successDesc || 'Winners will be notified via SMS.'}
            </Typography>
            <Typography
              className={classnames(
                'is-flex',
                'is-flex-centered',
                styles.largeMarginTop,
                styles.tick
              )}
            >
              <Icon color="secondary" name="check" />
            </Typography>
          </>
        ) : (
          <>
            <div className={classnames('is-flex', styles.descriptionWrapper)}>
              {giftImage && (
                <img
                  width={400}
                  height={400}
                  src={getImgixUrl(giftImage, ['fit=crop', 'h=400', 'w=400'])}
                  className={classnames(styles.giftImg, styles.marginRight)}
                  alt="Sign up Gift"
                />
              )}
              {desc && (
                <Typography
                  color="black-bis"
                  align={giftImage ? 'left' : 'centered'}
                >{desc}
                </Typography>
              )}
            </div>
            <SignUpForm
              source={source}
              onSubmitSuccess={onSubmitSuccess}
              trackEvent={trackEvent}
            />
          </>
        )}
        <TermsAndPrivacyLinks />
      </div>
    </div>
  );
};

PopupModalContent.propTypes = {
  heroImage: PropTypes.string.isRequired,
  hasSignedUp: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  giftImage: PropTypes.string,
  desc: PropTypes.node,
  onSubmitSuccess: PropTypes.func,
  source: PropTypes.string.isRequired,
  trackEvent: PropTypes.func,
  successHeading: PropTypes.string,
  successDesc: PropTypes.node,
};

PopupModalContent.defaultProps = {
  giftImage: null,
  onSubmitSuccess: null,
  desc: null,
  trackEvent: null,
  successHeading: null,
  successDesc: null,
};

export { PopupModalContent };
